import { render, staticRenderFns } from "./OfferTable.vue?vue&type=template&id=5324b932&scoped=true"
import script from "./OfferTable.vue?vue&type=script&lang=ts"
export * from "./OfferTable.vue?vue&type=script&lang=ts"
import style0 from "./OfferTable.vue?vue&type=style&index=0&id=5324b932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324b932",
  null
  
)

export default component.exports